import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { CompanyService } from '../../core/services/company.service';
import { CompanyList } from '../../shared/components/company/company-list/company-list';
import { LogService } from '../../core/services/log.service';

@Component({
  selector: 'app-search',
  imports: [CompanyList],
  templateUrl: './search.html',
  styleUrl: './search.scss'
})
export class Search implements OnInit {
  searchTerm: string = '';
  searchResults: any = {};
  loading: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private companyService: CompanyService,
    private logger: LogService
  ) {}

  ngOnInit(): void {
    this.route.queryParams.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe(params => {
      this.searchTerm = params['q'] || '';
      if (this.searchTerm) {
        this.performSearch();
      }
    });
  }

  performSearch(): void {
    this.loading = true;
    this.companyService.getCompaniesByFilters({ search: this.searchTerm }).subscribe({
      next: (res) => {
        this.searchResults = res;
        this.loading = false;
      },
      error: (err) => {
        this.logger.error('Erreur de recherche: '+ err);
        this.loading = false;
      }
    });
  }
}